import { useState } from 'react';

import { Container, Divider, Header, TitleGov } from './styles';

import { AuthSection } from './components/AuthSection';

import { AuthSectionSteps } from './types/AuthSectionSteps';

import TenMeetings from '../../assets/horizontal-white-logo.svg';

import { LoadingBackdrop } from '../../components/LoadingBackdrop';

export function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [stepLogin, setStepLogin] = useState<AuthSectionSteps>(
    AuthSectionSteps.LOGIN,
  );

  return (
    <Container>
      {isLoading && (
        <LoadingBackdrop text="Carregando" component="" loading={isLoading} />
      )}
      <Header>
        <img src={TenMeetings} alt="logo horizontal Ten" />
        <Divider />
        <TitleGov>MÓDULO DE GOVERNANÇA</TitleGov>
      </Header>

      <AuthSection
        isLoading={isLoading}
        stepLogin={stepLogin}
        setIsLoading={setIsLoading}
        setStepLogin={setStepLogin}
      />
    </Container>
  );
}
